import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GlobalResponse, User } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { AdminService } from '@app/services/admin.service';
import { ViewDoctorLeadDialogComponent } from '../view-doctor-lead/view-doctor-lead.component';
import { MatDialogRef, MatDialog } from '@angular/material';
import { UpdateDoctorLeadDialogComponent } from '../update-doctor-lead/update-doctor-lead.component';
import { CommonService } from '@app/shared-module/common-service.service';
import { DatePipe } from '@angular/common';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-doctor-lead',
  templateUrl: './doctor-lead.component.html',
  styleUrls: ['./doctor-lead.component.scss']
})
export class DoctorLeadComponent implements OnInit {
  user: User;
  isEditEnabled = false;
  doctorLeadList: any[] = [];
  length = 0;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  viewDocLead: MatDialogRef<ViewDoctorLeadDialogComponent>;
  editDocLead: MatDialogRef<UpdateDoctorLeadDialogComponent>;
  @BlockUI() blockUI: NgBlockUI;
  constructor(
    private adminSrv: AdminService,
    private toastr: ToastrService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.fetchDoctorLeadList();
    this.user = this.commonService.internalLoginValue;
    if (this.user && this.user.role && (this.user.role === Constants.ROLE_ADMIN || this.user.role === Constants.ROLE_MARKETING)) {
      this.isEditEnabled = true;
    } else {
      this.isEditEnabled = false;
    }
  }

  fetchDoctorLeadList() {
    this.blockUI.start();
    this.adminSrv.getDoctorLeads(this.pageSize, this.pageNumber).subscribe(
      (res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          // console.log(res.result);
          this.doctorLeadList = res.result.doctorLead;
          this.length = res.result.doctorLeadCount;
        }
      },
      (error: any) => {
        this.toastr.error(error);
      });
  }
  pageEvent(event) {
    // console.log(this.pageSize);
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchDoctorLeadList();
  }

  viewLead(item) {
    let dataLead: any;
    this.blockUI.start();
    this.adminSrv.fetchDoctorLeadDetails(item._id).subscribe(
      (data: GlobalResponse) => {
        this.blockUI.stop();
        if (data && data.message && data.message === Constants.STATUS_SUCCESS) {
          dataLead = data.result;
          // console.log('viewDoc');
          // console.log(item);
          this.viewDocLead = this.dialog.open(ViewDoctorLeadDialogComponent, {
            disableClose: false
          });
          this.viewDocLead.componentInstance.headerTitle = 'View Doctor Lead';
          this.viewDocLead.componentInstance.leadData = dataLead;
          this.viewDocLead.componentInstance.doctorLeadID = item._id;

          this.viewDocLead.afterClosed().subscribe(result => {
            if (result) {
              this.fetchDoctorLeadList();
              // console.log('closed status');
            }
            this.viewDocLead = null;
          });
        }
      });
  }

  editLead(item) {
    let dataLead: any;
    this.blockUI.start();
    this.adminSrv.fetchDoctorLeadDetails(item._id).subscribe(
      (data: GlobalResponse) => {
        this.blockUI.stop();
        if (data && data.message && data.message === Constants.STATUS_SUCCESS) {
          dataLead = data.result;
          this.editDocLead = this.dialog.open(UpdateDoctorLeadDialogComponent, {
            disableClose: false
          });
          this.editDocLead.componentInstance.headerTitle = 'Edit Doctor Lead';
          this.editDocLead.componentInstance.leadData = dataLead;
          this.editDocLead.componentInstance.doctorLeadID = item._id;

          this.editDocLead.afterClosed().subscribe(result => {
            if (result) {
              this.fetchDoctorLeadList();
              // console.log('closed status');
            }
            this.editDocLead = null;
          });
        }
      });
  }

  exportAsXLSX(): void {
    const header = {
      header: ['Doctor', 'Clinic', 'Email Id', 'Status', 'Phone No', 'Converted At', 'Converted By']
    };
    // const header = ['Doctor', 'Clinic', 'Trial End Period', 'Plan', 'Payment Date', 'Amount Paid', 'Subscription End Date'];
    const tempArray = [];
    for (const item of this.doctorLeadList) {
      const tempItem: any = {} as any;
      tempItem.doctor = item.first_name + item.last_name;
      tempItem.clinic_name = item.clinic_name;
      tempItem.email_id = item.email_id;
      tempItem.paid_amount = item.paid_amount;
      tempItem.phone_no = item.phone_no;
      tempItem.status = item.status;
      tempItem.converted_at = this.datePipe.transform(item.payment_details.payment_date, 'yyyy-MM-dd');
      tempItem.converted_by = item.converted_by ? item.converted_by.name : '';
      tempArray.push(tempItem);
    }
    this.commonService.exportAsExcelFile(tempArray, header, 'doctorLead');
    // this.commonService.exportTemplateAsExcel(tempArray, header);
  }
}
